import Dexie from 'dexie'

export const offlineDB = new Dexie('KaPerkOfflineDB')

// Keep v1 EXACTLY as it originally shipped — this is what already-installed
// devices have on disk. Never edit this block again.
offlineDB.version(1).stores({
    menuCache: '[item_id+branch_id], branch_id, category, classification',
    recipeCache: '[item_id+ingredient_id], item_id',
    variantRuleCache: '[item_id+variant_id+ingredient_id], item_id',
    inventoryCache: 'ingredient_id',
    offlineReserved: 'ingredient_id',
    metaCache: 'key',
    ordersCache: 'order_id, order_status, created_at',
    syncQueue: '++localId, type, status, clientRef, created_at',
    idMap: 'localKey, realId',
})

// v2: adds every table introduced after the original release. Dexie will
// run this upgrade automatically for any device still on v1, creating the
// missing object stores without touching existing data in the v1 tables.
offlineDB.version(2).stores({
    invMenuItemsCache: 'id, branch_id',
    invStockListCache: 'ingredient_id, branch_id',
    invRecipeRefCache: 'item_id, branch_id',

    variantCache: '[item_id+variant_id], item_id',
    modifierCache: '[item_id+modifier_id], item_id',

    orderItemsCache: 'order_item_id, order_id',
    orderTransactionsCache: 'order_id',

    customerLoyaltyCache: 'email, user_id',
    rewardsCache: 'reward_id, branch_id',
    offlineRedemptions: '++id, reward_id, loyaltyKey',
})

offlineDB.version(3).stores({
    baristaCache: 'barista_id, branch_id',
    scheduleCache: 'owner_key, branch_id',
    attendanceCache: 'id, owner_key, date, branch_id, [owner_key+date]',
})

offlineDB.version(4).stores({
    adminPinCache: 'branch_id',
})

offlineDB.version(5).stores({
    invTransactionsCache: 'inventory_transaction_id, branch_id, created_at',
    posTransactionsCache: 'order_transaction_id, branch_id, created_at',
})

offlineDB.version(6).stores({
    loyaltyTiersCache: 'id, tierLevel',
    loyaltyCatalogRewardsCache: 'id',
    loyaltyCatalogAchievementsCache: 'id',
    loyaltyCatalogCampaignsCache: 'id',
})
offlineDB.version(7).stores({
    ordersCache: 'order_id, order_status, created_at, branch_id',
})
offlineDB.version(8).stores({
    cashDrawerSessionCache: 'branch_id',
    cashDrawerTransactionsCache: 'transaction_id, session_id, created_at',
})

offlineDB.version(9).stores({
    cashDrawerLogsCache: 'session_id, branch_id, opened_at',
})

offlineDB.version(10).stores({
    remakeActivityLogsCache: 'activity_id, branch_id, opened_at',
})

offlineDB.version(11).stores({
    remakeRequestsCache: 'remake_request_id, branch_id, order_id, status',
})

// ── Add this after all .version() calls ──────────────────────────
offlineDB.on('blocked', () => {
    console.warn('[offlineDB] upgrade blocked — another tab has an older version open.')
})

offlineDB.on('versionchange', () => {
    // Another tab upgraded the schema; close this connection so the
    // other tab's upgrade can complete instead of deadlocking.
    offlineDB.close()
    window.location.reload()
})

